import React, { useEffect } from "react";
import { ContainerMain, Container, NewColumn, TitleContainer, Title } from "./styles";
import { Column } from '../styles';
import { DragDropContext, Droppable} from "react-beautiful-dnd";
import { useMediaQuery } from '@react-hook/media-query';
import { useTranslation } from "react-i18next";

/**
 * Container para as colunas de controle dos equipamentos
 * @param {object} Config Json com configurações dos objetos a serem exibidos
 * @param {boolean} allowEdit permissão para editar
 * @param {boolean} IsDetail caso seja detalhado
 * @param {Function} addColumn Função para adicionar um coluna
 * @param {Function} ChangeData função para alterar os objetos exibidos
 * @returns {ReactComponentElement} 
 */
const AllColumns = ({id, Config, allowEdit, IsDetail, addColumn, ChangeData, children}) => {
    var childs = React.Children.toArray(children);
    const isSmallScreen = useMediaQuery('(max-width: 720px)');
    // isDropDisabled ={true}
    // Método para movimentação dos elementos

    const { t } = useTranslation();

    const onDragEnd = result => {
        const { destination, source, draggableId, type } = result;
        // movimentação de dnd
        if (!destination) { return }
        if (destination.droppableId === source.droppableId && destination.index === source.index) { return }
        
        // se o dnd é uma coluna
        if (type === 'column') {
            const newColumnOrder = Object.values({...Config});
            const DraggableItem = newColumnOrder.find(item => item.id === draggableId);
            newColumnOrder.splice(source.index, 1);
            newColumnOrder.splice(destination.index, 0, DraggableItem);
            ChangeData(newColumnOrder)
            return;
        
        }
        
        //modifica a ordenação dos itens na coluna
        var start = Object.values({...Config}).find(item => item.id === destination.droppableId);
        var finish = Object.values({...Config}).find(item => item.id === source.droppableId);
        // const start = Config.columns[source.droppableId];
        // const finish = Config.columns[destination.droppableId];
        if (start === finish) {
            const newItensIds = Array.from(start.cards);
            const NewItens = newItensIds.find(item => item.id === draggableId);
            newItensIds.splice(source.index, 1);
            newItensIds.splice(destination.index, 0, NewItens);
            const newColumn = {
                ...start,
                cards: newItensIds
            }
            let newColumnId= (Object.entries(Config)).find(item => item[1] === start)[0]
            const newState = {
                ...Config,
                [newColumnId]: newColumn
            }
            ChangeData(Object.values(newState))
            return;
        }

        // altera a coluna do item    
        const startItensIds = Array.from(finish.cards);
        const ItemGo = startItensIds.find(item => item.id === draggableId);
        const newindex = startItensIds.indexOf(ItemGo);
        startItensIds.splice(newindex, 1);

        const finishItensIds = Array.from(start.cards);
        finishItensIds.splice(destination.index, 0, ItemGo);

        let finishColumn= (Object.entries(Config)).find(item => item[1] === start)[0];
        let initialColumn= (Object.entries(Config)).find(item => item[1] === finish)[0];
        start.cards = finishItensIds;
        finish.cards = startItensIds;

        const newState = {
            ...Config,
            [finishColumn]: start,
            [initialColumn]: finish
        }
        
        ChangeData(Object.values(newState))
    }

    useEffect(() => {
        childs = (React.Children.toArray(children));
    },[children])

    return (
        <ContainerMain id={id} $IsDetail={IsDetail}>
            <DragDropContext onDragEnd={onDragEnd}>
                {/* vertical */}
                <Droppable droppableId='all-columns' direction={isSmallScreen || IsDetail ? 'vertical' : 'horizontal'} type='column' index={0}>
                    {(provided) => (
                    <Container 
                    $IsDetail={IsDetail}
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    >
                        {childs.map(child => (
                            child
                        ))}
                        {provided.placeholder}
                        {allowEdit ? 
                            <NewColumn> 
                                <TitleContainer onClick={() => {addColumn()}}>
                                    <Column $width={'10%'}>
                                        <Title>+</Title>
                                    </Column>
                                    <Title>{t("components.all-columns.new-column.title")}</Title>
                                    <Column $width={'10%'}/>
                                </TitleContainer>
                            </NewColumn>
                        :
                            <></>
                        }
                    </Container>
                    )}
                </Droppable>
            </DragDropContext>
        </ContainerMain>
    )
}

export default AllColumns;
